import { render, staticRenderFns } from "./d-user-common-followers.vue?vue&type=template&id=dc60b998&scoped=true&"
import script from "./d-user-common-followers.vue?vue&type=script&lang=js&"
export * from "./d-user-common-followers.vue?vue&type=script&lang=js&"
import style0 from "./d-user-common-followers.vue?vue&type=style&index=0&id=dc60b998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc60b998",
  null
  
)

export default component.exports